import React from 'react';

import type { InspirationCardProps } from 'src/components/molecules/InspirationCard/InspirationCard';
import { Pagination } from 'src/components/molecules/Pagination/Pagination';
import { InspirationListing } from 'src/components/organisms/InspirationListing/InspirationListing';
import type { InspirationLayoutProps } from 'src/components/templates/InspirationLayout/InspirationLayout';
import { InspirationLayout } from 'src/components/templates/InspirationLayout/InspirationLayout';
import * as layoutStyles from 'src/components/templates/InspirationLayout/InspirationLayout.styles';
import { getInspirationPageHref } from 'src/utils/inspirationUrls';

export type InspirationCategoryProps = Omit<InspirationLayoutProps, 'children'> & {
  currentPage: number;
  heading: string;
  /** The category's page 1 URL, which the pagination links build on. */
  path: string;
  posts: InspirationCardProps[];
  totalPages: number;
};

export const InspirationCategory = ({
  currentPage,
  heading,
  path,
  posts,
  totalPages,
  ...layoutProps
}: InspirationCategoryProps) => (
  <InspirationLayout {...layoutProps}>
    <div css={layoutStyles.stack}>
      <InspirationListing heading={heading} posts={posts} />
      {totalPages > 1 && (
        <>
          <hr css={layoutStyles.divider} />
          <Pagination
            ariaLabel={`${heading} pages`}
            currentPage={currentPage}
            getPageHref={(page) => getInspirationPageHref(path, page)}
            totalPages={totalPages}
          />
        </>
      )}
    </div>
  </InspirationLayout>
);
